import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '../../../core/components/atoms/Button';
import { Icon } from '../../../core/components/atoms/Icon';
import { Toast, toast } from '../../../core/components/atoms/Toast';
import { Typography } from '../../../core/components/molecules/Typography';
import { useDoSearch } from '../hooks/useGetSearchResultHook';  
import { searchFilterStore } from '../stores/searchFilters';
import { searchStore } from '../stores/searchStore';
import { RenderTagsContainer } from '../components/TagsContainer';
import { RenderSearchContent } from '../components/SearchContent';
import Container from '../../../core/components/atoms/Container';
import PageHeader from '../../../core/components/molecules/Header';
import FilterSearch from '../components/ModalFiltro';
import './styles.css';

export function SearchingPage() {
  const { search } = useParams();

  const { mutate, isPending, isError } = useDoSearch();

  const { activeSearchString, resetFilterSearch } = searchFilterStore();
  const { searchResult } = searchStore();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (search) {
      if (activeSearchString !== search) {
        resetFilterSearch();
      }

      handleLoadSearch();
    }
  }, [search]);

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'error',
        message: 'Não foi possivel realizar a busca',
        title: 'Erro!',
      });
    }
  }, [isError]);

  const onSubmit = () => {
    setIsOpen(false);
    handleLoadSearch();
  };

  const handleLoadSearch = () => {
    if (search) {
      mutate(search);
    }
  };

  return (
    <Container gap='xxl' direction='col' className='xs:mb-[30px] xl:mb-[30px]'>
      <PageHeader
        title={search || 'Indefinido'}
        module='Resultados da busca por'
      />
      <div className='flex h-fit w-full flex-row items-end justify-between'>
        <Typography size='small'>
          {searchResult?.length || 0} resultados
        </Typography>
        <Button variant='text' onClick={() => setIsOpen(true)} className='p-0'>
          <Icon
            Icon='filter_list'
            type='material'
            className='xs:text-sm md:text-md'
          />
          <span className='xs:text-sm md:text-md '>Filtrar conteúdos</span>
        </Button>
      </div>
      <RenderTagsContainer callback={() => handleLoadSearch()} />
      <RenderSearchContent loading={isPending} callback={() => handleLoadSearch()} />
      <FilterSearch
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={() => onSubmit()}
      />
      {isError && <Toast />}
    </Container>
  );
}
